import { api_fetch_throws, LedgerAccount } from "@/api"
import { entity } from "simpler-state"
import { SelectItem } from "./autocomplete_select"

export const LedgerAccounts = entity<SelectItem[]>([])

export async function loadAccountCodes() {
  // `for_coding` leaves out the open-deductions holding account: dollars park there on their own,
  // and a deduction coded to it by hand can never be cleared out of it.
  let data = await api_fetch_throws<LedgerAccount[]>("/reason_codes?for_coding=true")
  let selections = data.map(account => ({
    id: account.id,
    name: account.expense_account,
    expense_account: account.expense_account,
    account_number: account.account_number,
    product_service: account.product_service ?? undefined,
  }))
  LedgerAccounts.set(selections)
}
